var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3337 13.3333H2.66699M14.667 18.6667H8.00033M2.66699 10.9333L2.66699 21.0667C2.66699 22.5601 2.66699 23.3069 2.95764 23.8773C3.2133 24.3791 3.62125 24.787 4.12302 25.0427C4.69345 25.3333 5.44019 25.3333 6.93366 25.3333L25.067 25.3333C26.5605 25.3333 27.3072 25.3333 27.8776 25.0427C28.3794 24.787 28.7874 24.3791 29.043 23.8773C29.3337 23.3069 29.3337 22.5601 29.3337 21.0667V10.9333C29.3337 9.43985 29.3337 8.69311 29.043 8.12268C28.7874 7.62092 28.3794 7.21297 27.8776 6.95731C27.3072 6.66666 26.5605 6.66666 25.067 6.66666L6.93366 6.66666C5.44019 6.66666 4.69345 6.66666 4.12302 6.95731C3.62125 7.21297 3.2133 7.62092 2.95764 8.12268C2.66699 8.69311 2.66699 9.43985 2.66699 10.9333Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.2ca07744de1b0ad04951d8521f5fe287.svg";
export { ForwardRef as ReactComponent };